import { combineReducers } from 'redux';
import { reducer as oidc } from 'redux-oidc';
import dialogs from './reducer_dialogs';
import section from './reducer_section';
import tiposZona from './reducer_tipos_zona';
import tiposPartida from './reducer_tipos_partida';
import grupoPartida from './reducer_grupo_partida';
import tiposMaquina from './reducer_tipos_maquina';
import modelosMaquina from './reducer_modelos_maquina';
import allArticulos from './reducer_all_articulos';
import tiposArticulo from './reducer_tipos_articulos';
import tipoGasto from './reducer_tipo_gasto';
import tipoZonaIva from './reducer_tipo_zona_iva';
import centros from './reducer_centros';
import centroDetalle from './reducer_centro_detalle';
import cajasCentro from './reducer_cajas_centro';
import zonaIvaCentro from './reducer_zonasiva_centro';
import centrosCentro from './reducer_centros_centro';
import tiposZonaIva from './reducer_tipos_zonas_iva';
import zonasCentro from './reducer_zonas_centro';
import zonaDetalles from './reducer_zona_detalles';
import zonaDetallesTipoPartida from './reducer_zona_detalles_tipo_partida';
import zonaProductos from './reducer_zona_detalles_productos';
import zonaProductosCaja from './reducer_zona_detalles_productos_caja';
import zonaMaquinas from './reducer_zona_maquinas';
import maeMaquinas from './reducer_maemaquinas';
import maquinaDetalle from './reducer_maquina_detalles';
import maquinaContadores from './reducer_maquina_detalles_contadores';
import maquinaIncidencias from './reducer_maquina_detalles_incidencias';
import maquinalicencias from './reducer_maquina_detalles_licencias';
import maquinaItvs from './reducer_maquina_detalles_itvs';
import maquinaCentros from './reducer_maquina_detalles_centros';
import contabCentro from './reducer_contab_centro';
import empresas from './reducer_empresas';
import datosCierreDiario from './reducer_datos_cierre_diario';
import centroDiaSelected from './reducer_centro_dia_selected';
import otrosDatosCierreDiario from './reducer_otros_datos_cierre_diario';
import artGastos from './reducer_art_gastos';
import artMKT from './reducer_art_mkt';
import tipoGastosCierre from './reducer_tipo_gastos_cierre';
import moverMaquinasOrigen from './reducer_acc_mover_maquinasOrigen';
import moverMaquinasDestino from './reducer_acc_mover_maquinasDestino';
import otrosDatosCierreSemanal from './reducer_otros_datos_cierre_semanal';
import resumenCierreSemanal from './reducer_resumen_cierre_semanal';
import resumenCierreDiario from './reducer_resumen_cierre_diario';

import datosCierreSemanal from './reducer_datos_cierre_semanal';
import loading from './reducer_loading';

import presupuesto from './reducer_presupuesto';
import presupuestoDetalle from './reducer_presupuesto_detalle';

import perfilesUsuario from './reducer_perfiles_usuario';
import usuarioDetalles from './reducer_perfiles_usuario_detalles';
import usuarioCentros from './reducer_perfiles_usuario_centro';

import saveState from './reducer_save_state';

import userProfile from './reducer_user_profile';
import navigation from './reducer_navigation';

import familia from './reducer_familia';
import subFamilia from './reducer_sub_familia';
import tipoFicha from './reducer_tipo_ficha';
import tipoFichaSub from './reducer_tipo_ficha_sub';
import tipoMovRedem from './reducer_tipo_mov_redem';
import promocion from './reducer_promocion';
import motivo from './reducer_motivo';
import segmentacion from './reducer_segmentacion';

const rootReducer = combineReducers({
    loading,
    dialogs,
    section,
    tiposZona,
    grupoPartida,
    tiposPartida,
    tiposMaquina,
    modelosMaquina,
    tiposArticulo,
    tipoZonaIva,
    allArticulos,
    tipoGasto,
    centros,
    empresas,
    centroDetalle,
    cajasCentro,
    zonasCentro,
    zonaIvaCentro,
    centrosCentro,
    tiposZonaIva,
    zonaDetalles,
    zonaDetallesTipoPartida,
    zonaProductos,
    zonaProductosCaja,
    zonaMaquinas,
    maeMaquinas,
    maquinaDetalle,
    maquinaContadores,
    maquinaIncidencias,
    maquinalicencias,
    maquinaItvs,
    maquinaCentros,
    contabCentro,
    datosCierreDiario,
    centroDiaSelected ,
    otrosDatosCierreDiario,
    artGastos,
    artMKT,
    tipoGastosCierre,
    moverMaquinasOrigen,
    moverMaquinasDestino,
    datosCierreSemanal,
    otrosDatosCierreSemanal,
    resumenCierreSemanal,
    resumenCierreDiario,
    presupuesto,
    presupuestoDetalle,
    perfilesUsuario,
    usuarioDetalles,
    usuarioCentros,
    oidc,
    saveState,
    userProfile,
    navigation,
    familia,
    subFamilia,
    tipoFicha,
    tipoFichaSub,
    tipoMovRedem,
    promocion,
    motivo,
    segmentacion,
});

export default rootReducer;